export default {
	filtro: {
		numero: null,
		idProcesso: null,
		idsFornecedores: [],
		numeroEditais: [],
		idsTipos: [],
	},
	paginacao: {
		rowsPerPage: 100,
	},
	modelFiltro: {
		id: null,
		numero: null,
	},
	porNumeroEItemProcesso: {
		filtro: {
			idsTipos: [],
			numeroEdital: null,
			idProcesso: null,
			idFornecedor: null,
			isUsadoEmAta: null,
		},
		paginacao: {
			rowsPerPage: 100,
		},
	},
}
